
export const services = [
    {
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Data Analytics",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Numismatics Expert",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Umair';
 
export const experiences = [
    {
      'company': 'Internship Studio for Artificial Intelligence',
      'role': 'Artificial Intelligence Intern',
      'duration': 'Feb 2024 – July 2024',
      'logo': 'https://ugc.production.linktr.ee/zmrm5kk0TfGNgDTnQxVO_OsmsYPpIS7LyFk8s?io=true&size=avatar-v3_0',
      'points': [
        'Developed an AI agent using Q-learning for navigating and optimizing strategies in various Snake game levels, focusing on maximizing scores and adapting to dynamic environments.',
        'Implemented a deep Q-network (DQN) with PyTorch, leveraging experience replay and target network updates, improving game performance by 15%.',
        'Developed a VGG19-based style transfer model, significantly reducing the loss function by 85% over 4000 iterations, producing high-quality image results.',
        'Worked on PCA with ANN for face recognition and drowsiness detection systems, enhancing real-time monitoring and safety applications.',
        'Gained proficiency in PyTorch, TensorFlow, and advanced machine learning techniques, contributing to significant project improvements.'
      ],
      'url': 'https://internshipstudio.com/',
    },
    {
      'company': 'Unified Mentor',
      'role': 'Data Analyst Intern',
      'duration': 'Feb 2024 – Mar 2024',
      'logo': 'https://blog.unifiedmentor.com/wp-content/uploads/2023/09/Blue-with-Colorful-Confetti-Sports-Invitation-17.jpg',
      'points': [
        'Delivered actionable insights for retail sales performance and customer behavior, driving informed decision-making.',
        'Utilized Power BI and SQL for data-driven analysis, enhancing sales strategy and operations.',
        'Developed comprehensive reports and dashboards, providing clear and actionable insights to senior management.',
        'Collaborated with marketing teams to analyze customer segmentation data, optimizing targeted marketing campaigns.'
      ],
      'url': 'https://unifiedmentor.com/',
    },
    {
      'company': 'KPMG AU',
      'role': 'Data Analytics Intern',
      'duration': 'Oct 2023 – Feb 2024',
      'logo': 'https://assets.kpmg.com/is/image/kpmg/kpmg-logo-1',
      'points': [
        'Spearheaded Data Quality assessment and insights generation, significantly improving data quality by 15%.',
        'Successfully executed a Big Mart Sales Prediction project, resulting in a notable 5% enhancement in marketing effectiveness.',
        'Prepared a PowerPoint deck and video presentation to communicate key insights, leading to a 10% increase in stakeholder approval.',
        'Collaborated with cross-functional teams to identify data-related issues and recommend solutions, improving overall data integrity.',
        'Automated data processing tasks, reducing manual effort and increasing efficiency by 20%.'
      ],
      'url': 'https://home.kpmg/xx/en/home.html',
    }
  ];
  
  export const EMAIL_JS_SERVICE_ID = 'service_90wb9t5';
  export const EMAIL_JS_TEMPLATE_ID = 'template_8l87rew';
  export const EMAIL_JS_PUBLIC_KEY = 'pHPjc9RGGkF66r86N';
  